import {NgModule} from '@angular/core';
import {DynamicArticleItemsComponent} from "@iw-shop/dynamic-article/components/items/dynamic-article-items.component";
import {DynamicArticlesComponent} from "@iw-shop/dynamic-article/components/dynamic-articles/dynamic-articles.component";
import {AsyncPipe, NgClass, NgForOf, NgIf} from "@angular/common";

@NgModule({
    declarations: [
        DynamicArticlesComponent,
        DynamicArticleItemsComponent
    ],
    imports: [
        NgIf,
        NgForOf,
        NgClass,
        AsyncPipe
    ],
    exports: [
        DynamicArticlesComponent,
        DynamicArticleItemsComponent
    ]
})
export class DynamicArticleModule {
}
